<template>
  <div class="page-content" style="margin: 0px; width: 100%">
    <PageHeader v-if="check"></PageHeader>
    <Main
        v-if="$route.name === names.MAIN && check"
    ></Main>
    <WelcomePage v-else-if ="$route.name === names.MAIN && !check"
        @goPortal="goPortal"
        @goGuard="goGuard"
    ></WelcomePage>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import names from "@/modules/core/routers/names"
import PageHeader from "../menus/PageHeader";
import Main from "./Main";
import {mapActions, mapGetters} from "vuex";
import admin from "@/urls/roles/admin";
import viewer from "@/urls/roles/viewer";
import entitled from "@/urls/roles/entitled";
import representative from "@/urls/roles/representative";
import responsible from "@/urls/roles/responsible";
import guard from "@/urls/roles/guard";
import admin_names from "@/modules/admin/routers/names";
import viewer_names from "@/modules/viewer/routers/names";
import entitled_names from "@/modules/entitled/routers/names";
import representative_names from "@/modules/representative/routers/names";
import responsible_names from "@/modules/responsible/routers/names";
import guard_names from "@/modules/guard/routers/names";
import WelcomePage from "@/modules/core/components/WelcomePage.vue";
import {checkIsDevelopmentServer} from "@/helper";

export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Base",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: {WelcomePage, Main, PageHeader},
  data() {
      return {
        left_menu_list: [
          {title: "Главная страница", icon: "home", included: true, router: {name:names.MAIN, params:{}}}
        ],
        check: false
      }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: "user/isAuthenticate",
      isMobileView: "isMobileView"
    })
  },
  methods: {
    checkIsDevelopmentServer: checkIsDevelopmentServer,
    goGuard(){
      this.check = true
    },
    goPortal(){
      document.location.href = process.env.VUE_APP_LOGIN_HOST + String(`?from=${document.location.href}`)
    },
    loadLeftmenu() {
      this.$store.commit("mainpage/changeTitle", "Заказ пропусков");
      // this.$store.commit('leftmenu/replaceInstances', getInstMenu());
      // this.$store.commit('leftmenu/selectInstance', getInstNameByRouterName(names.MAIN));
      // this.$store.commit('leftmenu/replaceItems', this.getLeftMenu());
    },
    getLeftMenu() {
        let with_category_uid = (name) => {
            return {name: name, params: {category: this.$route.params.category}}
        };
        let menu = []
        for (let el in this.left_menu_list){
          menu.push(this.left_menu_list[el])
        }
        return menu
    },
    checkAuthenticate(finalizer=()=>{}){
      if(this.isAuthenticated){
        let is_admin = admin.ADMIN.ALLOWED()
        let is_viewer = viewer.VIEWER.ALLOWED()
        let is_entitled = entitled.ENTITLED.ALLOWED()
        let is_representative = representative.REPRESENTATIVE.ALLOWED()
        // let is_responsible = responsible.RESPONSIBLE.ALLOWED()
        let is_guard = guard.GUARD.ALLOWED()
        if(is_admin || is_viewer || is_entitled || is_representative || is_guard){
          finalizer()
        }
        else
          this.check = true
      }
      else
        this.check = false
      if(this.$route.query.password)
        this.check = true
      if (window.$cookies.get("guard_password"))
        this.check = true
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.checkAuthenticate(
        ()=>{
          this.loadLeftmenu()
        }
    )
    next()
  },
  created() {
    this.checkAuthenticate(
      ()=>{
        this.$store.commit("leftmenu/enableLeftMenu");
        if (!this.isMobileView) this.$store.commit("leftmenu/showLeftMenu");
        this.loadLeftmenu()
        if (admin.ADMIN.ALLOWED())
          this.$router.push({name: admin_names.MAIN}).catch(() => {})
        else if (viewer.VIEWER.ALLOWED())
          this.$router.push({name: viewer_names.MAIN}).catch(() => {})
        else if (entitled.ENTITLED.ALLOWED())
          this.$router.push({name: entitled_names.ORDERS.LIST}).catch(() => {})
        else if (representative.REPRESENTATIVE.ALLOWED())
          this.$router.push({name: representative_names.ORDERS.LIST}).catch(() => {})
        // else if (responsible.RESPONSIBLE.ALLOWED())
        //   this.$router.push({name: responsible_names.ORDERS.LIST})
        else if (guard.GUARD.ALLOWED())
          this.$router.push({name: guard_names.ORDERS.LIST}).catch(() => {})
        else
          this.check = true
      }
    )
  }
}
</script>

<style scoped>
    .border-right {
        border-right: 2px solid var(--steel-gray);
    }

</style>
